// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
import { Modal, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import MUIDataTable from "mui-datatables";
import Select from 'react-select';
// CUSTOM COMPONENTS
import ModalBlock from '../../../../components/ModalBlock';
import CustomBlock from '../../../../components/CustomBlock';
import Button from '../../../../components/Button';
// SERVICES AND HELPERS
import constants from '../../../../../constants/constants';
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import TeamMemberValidator from '../../../../../helpers/validators/TeamMemberValidator';
import * as jobTeamMemberService from '../../../../../services/service/jobTeamMemberService';

const JobScheduleConflictModal = (props) => {
    const { isJobConflictModalOpen, setIsJobConflictModalOpen, conflictedJobSchedules, setOverrideScheduleIds,
        overrideScheduleIds, formik, skipScheduleIds, setSkipScheduleIds, handleModalClose } = props;

    const handleJobConflictModalClose = () => {
        setIsJobConflictModalOpen(false);
        handleModalClose();
    }

    const removeUserFromSelection = (jobSchedule) => {
        setSkipScheduleIds([
            ...skipScheduleIds,
            { scheduleId: jobSchedule.id, userId: jobSchedule.userId, start: jobSchedule.start, end: jobSchedule.end }
        ]);
    }

    const initiateTransfer = (jobSchedule) => {
        setOverrideScheduleIds([...overrideScheduleIds, { scheduleId: jobSchedule.id, userId: jobSchedule.userId }]);
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                setCellProps: () => ({
                    'data-aes-field': 'actions',
                    'data-aes-label': 'Actions'
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        overrideScheduleIds.map(x => x.scheduleId).includes(conflictedJobSchedules[dataIndex].id) ?
                            <i>Transfer Initiated</i> :
                            skipScheduleIds.map(x => x.scheduleId).includes(conflictedJobSchedules[dataIndex].id) ?
                                <i>
                                    De-selected
                                </i> :
                                <div className="aes-admin-listing-actions">
                                    <button
                                        className="btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => initiateTransfer(conflictedJobSchedules[dataIndex])}
                                    >
                                        Transfer
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => removeUserFromSelection(conflictedJobSchedules[dataIndex])}
                                    >
                                        Deselect
                                    </button>
                                </div>
                    );
                }
            },
        },
        {
            name: "fullName",
            label: "Name",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'primary',
                    'data-aes-label': 'Employee',
                    style: { width: "20%" }
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="tc-user-block">
                            <div
                                className="img-block background-image-container"
                                style={{ backgroundImage: `url(${conflictedJobSchedules[dataIndex].imageUrl ? (constants.API_URL + conflictedJobSchedules[dataIndex].imageUrl) : ("/media/users/default.jpg")})` }}
                            >
                            </div>

                            <div className="user-info-block">
                                <p className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                    {conflictedJobSchedules[dataIndex].name}
                                </p>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "projectNumber",
            label: "Project#",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-number',
                    'data-aes-label': 'Project Number'
                }),
            }
        },
        {
            name: "jobName",
            label: "Project Name",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'project-name',
                    'data-aes-label': 'Project Name'
                }),
            }
        },
        {
            name: "start",
            label: "Start Time",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'start',
                    'data-aes-label': 'Start Time'
                }),
            }
        },
        {
            name: "end",
            label: "End Time",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'end',
                    'data-aes-label': 'End Time'
                }),
            }
        }
    ];

    return (
        <>
            <ModalBlock
                show={isJobConflictModalOpen}
                contentHeader="Schedule Conflicts"
                contentDescription="Please resolve the following schedule conflicts in order to schedule the following team members."
                onHide={handleJobConflictModalClose}
                backdrop="static"
                size="lg"
                closeAction
                centered
                padded
            >
                <CustomBlock className="content-container aes-admin-listing-page aes-admin-listing-page--schedule-conflicts">
                    <div className="aes-admin-listing">
                        <MUIDataTable
                            className="aes-admin-listing-surface"
                            data={conflictedJobSchedules}
                            columns={columns}
                            options={{
                                responsive: 'standard',
                                rowsPerPage: 5,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                filter: false,
                                sort: false,
                                viewColumns: false,
                                search: false,
                                download: false,
                                print: false,
                                setTableProps: () => ({
                                    className: 'aes-admin-listing-table'
                                })
                            }}
                        />
                    </div>
                </CustomBlock>
                <CustomBlock className="content-container--actions">
                    <Button
                        text="Cancel"
                        className="grey--bg"
                        onClick={handleJobConflictModalClose}
                    />
                    <Button
                        disabled={((overrideScheduleIds.length + skipScheduleIds.length) !== conflictedJobSchedules.length) || formik.isSubmitting}
                        type="submit"
                        text="Schedule"
                        className="success--bg"
                        onClick={formik.handleSubmit}
                        loading={formik.isSubmitting}
                    />

                </CustomBlock>

            </ModalBlock>
        </>
    )
}

export default JobScheduleConflictModal;
